import { useTranslation } from 'react-i18next';
import { Flex } from 'antd';
import { useScheduleUpsertModalB50 } from '../../../../context/ScheduleCreateModalContext';
import {
  ExpectedCompletionDescription,
  ExpectedCompletionTitle,
  ExpectedCompletionValue,
  IconContainer,
} from './ExpectedCompletion.styles';
import { kccThemeConstants } from 'config/theme/kccTheme/kccTheme';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

export const ExpectedCompletionB50 = (): JSX.Element => {
  const { t } = useTranslation();

  const { expectedCompletionTime, scheduleRouteRoutine } = useScheduleUpsertModalB50();

  if (!scheduleRouteRoutine) {
    return <></>;
  }

  return (
    <Flex vertical gap={kccThemeConstants.SPACING.XXS} align="center" justify="center">
      <Flex align="center" justify="center">
        <ExpectedCompletionTitle>{t('createSchedule.expectedCompletion')}</ExpectedCompletionTitle>
      </Flex>

      <Flex align="center" gap={kccThemeConstants.SPACING.LG}>
        <Flex vertical align="center" gap={kccThemeConstants.SPACING.XXS}>
          <Flex align="center" gap={kccThemeConstants.SPACING.XXS}>
            <IconContainer>
              <SvgIcon name="cleanStar" />
            </IconContainer>

            <ExpectedCompletionValue>
              {expectedCompletionTime.finishCleaningTime.format('hh:mm A')}
            </ExpectedCompletionValue>
          </Flex>

          <ExpectedCompletionDescription>{t('createSchedule.finishCleaning')}</ExpectedCompletionDescription>
        </Flex>

        <Flex vertical align="center" gap={kccThemeConstants.SPACING.XXS}>
          <Flex align="center" gap={kccThemeConstants.SPACING.XXS}>
            <IconContainer>
              <SvgIcon name="batteryPercentage" />
            </IconContainer>

            <ExpectedCompletionValue>
              {expectedCompletionTime.fullyChargedTime.format('hh:mm A')}
            </ExpectedCompletionValue>
          </Flex>

          <ExpectedCompletionDescription>{t('createSchedule.fullyCharged')}</ExpectedCompletionDescription>
        </Flex>
      </Flex>
    </Flex>
  );
};
